import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { HomeService } from '@connect-services/client/services/home.service';
import { AbstractComponent } from '@connect-services/src/app/abstract.component';

export abstract class AbstractLayerProjectComponent extends AbstractComponent {
    protected readonly homeService = inject(HomeService);
    protected readonly router = inject(Router);

    public override async destroyCallback(): Promise<void> {
        this.homeService.resetSources();

        await this.homeService.initSources();
    }
}
